import { Game } from "../types";
import { getScoreForPlayer } from "./getScoreForPlayer";

export const getTotalScore = (game: Game) =>
  game.players
    .map(player =>
      getScoreForPlayer(player.tricks, player.indicesOfTricks, 0, game.round),
    )
    .reduce((sum, current) => sum + current, 0);
